import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils';

// Async thunks
export const fetchPackages = createAsyncThunk(
    'deploy/packages',
    async () => {
        const response = await apiFetch('api/t/packages');
        return await response.json();
    }
);

export const fetchAvailability = createAsyncThunk(
    'fetch/availableResources',
    async (packageId) => {
        const response = await apiFetch(`api/t/available/${packageId}`);
        return await response.json();
    }
);

export const sendOrder = createAsyncThunk(
    "deploy/order",
    async (payload) => {
        const res = await apiFetch("api/d/deploy", {
            method: "POST",
            body: JSON.stringify(payload),
            idempotencyAction: "deploy:order"
        });

        return await res.json();
    }
);

// Slice
const deploymentSlice = createSlice({
    name: 'deploy',
    initialState: {
        packages: [],
        resources: [],
        regions: [],
        sizes: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPackages.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPackages.fulfilled, (state, action) => {
                state.packages = action.payload.packages;
                state.loading = false;
            })
            .addCase(fetchPackages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchAvailability.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAvailability.fulfilled, (state, action) => {
                state.resources = action.payload ?? [];
                if (state.resources && typeof state.resources.flatMap == "function") {
                    state.regions = state.resources?.flatMap(r => r?.available?.regions) ?? [];
                    state.sizes = state.resources?.flatMap(r => r?.available?.sizes) ?? [];
                }
                state.loading = false;
            })
            .addCase(fetchAvailability.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(sendOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendOrder.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendOrder.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default deploymentSlice.reducer;
